import React from "react";
import { Collapse } from "react-collapse";
import {AiOutlineMinus} from "react-icons/ai"
import {AiOutlinePlus} from "react-icons/ai"

const AccordionItem = ({open,toggle,title,desc, list1, list2, list3,list4,list5,list6}) => {
    return(
        
        <div className="font-alibaba sm:px-8">
            <div className="py-6 flex justify-between items-center cursor-pointer" onClick={toggle}>
                <p className="font-noto font-bold text-[18px] sm:text-[20px] px-2">{title}</p>
                <div className="text-lg">
                    {open ? <AiOutlineMinus /> : <AiOutlinePlus />}
                </div>
            </div>
            <Collapse isOpened ={open} >
                <div>
                    <div className="pb-4 text-[#5F5D5E] text-[16px]">{desc}</div>

                    <ol className="list-disc  ">
                        <li className="text-[16px] text-[#5F5D5E] ml-12 font-alibaba">{list1}</li>
                        <li className="text-[16px] text-[#5F5D5E] ml-12 font-alibaba">{list2}</li>
                        <li className="text-[16px] text-[#5F5D5E] ml-12 font-alibaba">{list4}</li>
                        <li className="text-[16px] text-[#5F5D5E] ml-12 font-alibaba">{list3}</li>
                        <li className="text-[16px] text-[#5F5D5E] ml-12 font-alibaba">{list5}</li>
                        <li className="text-[16px] text-[#5F5D5E] ml-12 font-alibaba">{list6}</li>
                    </ol>
                </div>
            </Collapse>
            <hr className="text-grey font-semibold border" />
        </div>
    );
}

export default AccordionItem ;